(function () {
  "use strict";
  if (!/\/products\/[^/]+\/?$/.test(location.pathname)) return;

  function money(cents) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(cents / 100);
  }

  function designerFetch(url, options) {
    return fetch(url, options).catch(function () { return fetch(url, options); });
  }

  function legacyProductSection(main) {
    var productInfo = main && main.querySelector(".product__info-wrapper");
    return productInfo && productInfo.closest("section.shopify-section");
  }

  function placeProductionDesigner(root) {
    if (root.dataset.vdReplacesProductMain !== "true") return;
    var main = document.querySelector("main");
    var legacy = legacyProductSection(main);
    if (main && root.parentNode !== main) main.insertBefore(root, legacy || main.firstChild);
  }

  function activateProductionDesigner(root) {
    if (root.dataset.vdReplacesProductMain !== "true") return;
    var legacy = legacyProductSection(document.querySelector("main"));
    if (!legacy || legacy.contains(root)) return;
    legacy.hidden = true;
    legacy.setAttribute("aria-hidden", "true");
    legacy.dataset.vdReplacedByDesigner = "true";
  }

  function init(root) {
    var freeformController, freeformFontListKey;
    if (root.dataset.vdInitialized === "true") return;
    root.dataset.vdInitialized = "true";
    var api = root.dataset.apiBase;
    var variantId = root.dataset.variantId;
    var productId = root.dataset.productId;
    var productHandle = root.dataset.productHandle;
    var wallMode = root.dataset.vdMultiline === "true";
    var memorialMode = productHandle === "ilm-text";
    var catalog;
    var currentPreview;
    var selectedFont;
    var selectedCategory = "all";
    var fontListExpanded = false;
    var textRuns = [];
    var previousText = "";
    var selectionStart = 0;
    var selectionEnd = 0;
    var selectedRanges = [];
    var fontObserver;
    var fontLoads = Object.create(null);
    var proportionsLocked = true;
    var sizingBasis = "width";
    var distortionAccepted = false;
    var styleHistory = [];
    function previewFontFamily(font) {
      return "VDDecal_" + font.id.replace(/-/g, "_");
    }
    function loadFontPreview(font, target) {
      if (!font || !font.previewUrl || !window.FontFace || !document.fonts) return;
      var family = previewFontFamily(font);
      if (!fontLoads[font.id]) {
        var face = new window.FontFace(family, 'url("' + font.previewUrl + '") format("truetype")', {
          style: font.style || "normal",
          weight: String(font.weight || 400)
        });
        fontLoads[font.id] = face.load().then(function (loaded) {
          document.fonts.add(loaded);
          return family;
        }).catch(function () { return ""; });
      }
      fontLoads[font.id].then(function (loadedFamily) {
        if (loadedFamily && target.isConnected) target.style.fontFamily = '"' + loadedFamily + '", sans-serif';
      });
    }
    var timer;
    var quoteTimer;
    var requestNumber = 0;
    var quoteRequestNumber = 0;
    var el = function (selector) { return root.querySelector(selector); };
    var all = function (selector) { return Array.from(root.querySelectorAll(selector)); };
    var layout = el("[data-vd-layout]");
    var status = el("[data-vd-status]");
    var text = el("[data-vd-text]");
    var widthInput = el("[data-vd-width]");
    var heightInput = el("[data-vd-height]");
    var lockButton = el("[data-vd-lock]");
    var distortionAck = el("[data-vd-distortion-ack]");
    var color = el("[data-vd-color]");
    var quantity = el("[data-vd-quantity]");
    var search = el("[data-vd-font-search]");
    var approval = el("[data-vd-approval]");
    var submit = el("[data-vd-submit]");
    var submitting = false;
    var manualChoice = document.createElement("input");
    manualChoice.type = "checkbox";
    var manualPanel = document.createElement("div");
    manualPanel.className = "vd-text-manual-panel";
    manualPanel.innerHTML = "<label class=\"vd-text-manual-choice\"><span></span><span><strong>I’d like help - send me a proof</strong><small>Tell us what needs adjusting. Our team will send a proof for approval before production.</small></span></label><div class=\"vd-text-manual-notes\" hidden><label>What would you like us to change?<textarea maxlength=\"2000\" rows=\"4\" placeholder=\"For example: Bring the words closer together and use a bolder font.\"></textarea></label><small>Your displayed price is charged at checkout. Changes to size, material, or scope may affect the price. Production waits for your approval of the revised proof.</small></div>";
    manualPanel.querySelector(".vd-text-manual-choice > span").appendChild(manualChoice);
    var manualNotes = manualPanel.querySelector("textarea");
    var existingAgreement = approval.closest("label");
    existingAgreement.after(manualPanel);
    var proofStyle = document.createElement("style");
    proofStyle.textContent = '.vd-text-manual-panel{margin:14px 0 22px;font-size:16px;line-height:1.5}.vd-text-manual-choice{display:flex!important;gap:12px;align-items:flex-start;padding:16px;border:1px solid #cdd2dc;border-radius:12px;cursor:pointer}.vd-text-manual-choice:has(input:checked){border-color:#ef3b25;background:#fff6f3}.vd-text-manual-panel small{display:block;font-size:14px;color:#535e6c;margin-top:8px}.vd-text-manual-panel input{accent-color:#ef3b25}.vd-text-manual-notes{padding:16px 0}.vd-text-manual-notes[hidden]{display:none!important}.vd-text-manual-notes label{display:block!important}.vd-text-manual-notes textarea{display:block;width:100%;font:inherit;padding:12px;margin-top:8px;border:1px solid #bdc4d0;border-radius:10px;resize:vertical}';
    document.head.appendChild(proofStyle);
    manualChoice.addEventListener("change", function(){if(manualChoice.checked)approval.checked=false;manualPanel.querySelector(".vd-text-manual-notes").hidden=!manualChoice.checked;updateApprovalState();});
    manualNotes.addEventListener("input", updateApprovalState);
    approval.addEventListener("change",function(){if(approval.checked){manualChoice.checked=false;manualPanel.querySelector(".vd-text-manual-notes").hidden=true;}updateApprovalState();});
    var error = el("[data-vd-error]");
    var fontSize = el("[data-vd-font-size]");
    var editAll = el("[data-vd-edit-all]");
    var previewWords = el("[data-vd-preview-words]");
    var reverseField = el("[data-vd-reverse-field]");
    var reverseSummaryRow = el("[data-vd-summary-reversed-row]");
    var lineInputsContainer = el("[data-vd-line-inputs]");
    var socialDefaults = {"custom-multisocial-decal":"instagram","venmomedecal":"venmo","2linevenmomedecal":"venmo","custom-byte-decal":"byte","custom-youtube-decal":"youtube","custom-spotify-decal":"spotify","twitch-custom":"twitch","custom-emailaddress":"email","custom-phonenumber":"phone","custom-kik-decal":"kik","custom-skype-decal":"skype","custom-wordpress-decal":"wordpress","custom-tumblr-decal-02":"tumblr","custom-mixer-decal":"mixer","custom-blogger-decal":"blogger","custom-onlyfans-decal":"onlyfans","custom-instagram-new-02":"instagram","custom-snapchat-decal":"snapchat","custom-instagram-decal-new":"instagram-filled","custom-tiktok-decal":"tiktok"};
    socialDefaults['custom-twitter-id-decal']='twitter';socialDefaults['custom-x-decal']='x';
    var socialMode = !!socialDefaults[productHandle];
    var socialIcons = socialMode ? [socialDefaults[productHandle]] : [];
    var maxIcons = ["2linevenmomedecal","custom-wordpress-decal","custom-emailaddress","custom-phonenumber"].indexOf(productHandle) >= 0 ? 1 : 4;
    var fixedPair = productHandle === "cusnatvrenuv";
    var boatMode = productHandle === "cuborenuhidn" || productHandle === "cujetskirenu";
    var drumMode = productHandle === "cudrhevidest";
    var truckMode = productHandle === "custom-truck-door-lettering";
    var verticalMode = productHandle === "verticaltextdecal";
    function specialPreview(result) {
      var windshieldMode=productHandle === "cuwilevidest", skateboardMode=productHandle === "cusktevidest";
      if (!boatMode && !drumMode && !truckMode && !windshieldMode && !skateboardMode) return;
      var container = el("[data-vd-special-photo]");
      var measured = el(".vd-decal__measured-art");
      var svg = el("[data-vd-preview]");
      container.style.cssText += ";position:relative;aspect-ratio:1;min-height:0;padding:0;";
      var diameter = drumMode ? Number(el("[data-vd-drum-size]").value) : 0;
      // Example combined two-door span is 72 inches across 72% of this photograph.
      // Preserve physical scaling: a 6-inch decal must not fill the door.
      var w = drumMode ? result.widthInches / diameter * 76 : boatMode ? result.widthInches / 40 * 70 : result.widthInches / 72 * 72;
      var h = drumMode ? result.heightInches / diameter * 76 : boatMode ? result.heightInches / 40 * 70 : w * result.heightInches / result.widthInches;
      if(windshieldMode || skateboardMode){w=result.widthInches/(windshieldMode?60:32)*(windshieldMode?84:90);h=w*result.heightInches/result.widthInches;}
      if (!container.dataset.originalPhoto) container.dataset.originalPhoto = container.style.backgroundImage;
      var fitsTruck = !truckMode || (result.widthInches <= 72 && result.heightInches <= 18);
      container.style.backgroundImage = fitsTruck ? container.dataset.originalPhoto : "none";
      var truckClose = truckMode && fitsTruck && result.widthInches <= 12 && result.heightInches <= 5 && container.dataset.vdTruckClosePhoto;
      if (truckClose) {
        // Same physical scaling as the shared high-resolution door close-up.
        w = result.widthInches / 12 * 65;
        h = result.heightInches / 12 * 65;
        container.style.backgroundImage = 'url("' + container.dataset.vdTruckClosePhoto + '")';
      }
      if (truckMode) container.dataset.truckView = truckClose ? "close" : fitsTruck ? "full" : "artwork";
      if (truckMode && !fitsTruck) { w = 72; h = w * result.heightInches / result.widthInches; }
      measured.style.cssText = "position:absolute;left:" + (productHandle === "cujetskirenu" ? 44 : 50) + "%;top:" + (productHandle === "cujetskirenu" ? 47.5 : windshieldMode ? 36 : skateboardMode ? 50 : drumMode ? 46 : boatMode ? 52 : truckClose ? 60 : fitsTruck ? 57 : 50) + "%;transform:translate(-50%,-50%);width:" + w + "%;height:" + h + "%;display:block;margin:0;padding:0";
      svg.style.cssText = "width:100%;height:100%;max-height:none;display:block";
      el(".vd-decal__height-guide").hidden = true;
      el(".vd-decal__preview-note").textContent = truckMode && fitsTruck ? (truckClose ? "Door close-up. " : "Lower-door placement. ") + "Scaled example; measure your own vehicle. Finished decal dimensions shown above." : "Example placement • Finished decal dimensions shown above • Black artwork for clarity";
    }
    var fixedPrefix = productHandle === "custom-got-decal" ? "got " : ["hashtag-decal","custom-hashtag-decal"].indexOf(productHandle) >= 0 ? "#" : productHandle === "custom-yourtext" ? "@" : "";
    var fixedSuffix = productHandle === "custom-got-decal" ? "?" : "";
    function stripAffixes(value) { return fixedPrefix && value.startsWith(fixedPrefix) ? value.slice(fixedPrefix.length, fixedSuffix ? -fixedSuffix.length : undefined) : value; }
    function joinedText(inputs) { return fixedPrefix + inputs.map(function(input){return input.value;}).join("\n") + fixedSuffix; }
    var letterMode = productHandle === "custom-letter-decal" || productHandle === "single-letter-decal";
    var singleLineBand = productHandle === "cucubawaorca" || socialMode || letterMode || ["custom-got-decal","custom-kik-decal","custom-email-decal","custom-skype-decal","custom-wordpress-decal","custom-tumblr-decal-02","custom-mixer-decal","custom-blogger-decal","custom-onlyfans-decal","hashtag-decal","custom-instagram-new-02","custom-snapchat-decal","custom-instagram-decal-new","cusnatvrenuv"].indexOf(productHandle) >= 0;
    var maximumLines = singleLineBand ? 1 : productHandle === "cumaleaddany" ? 5 : 10;
    previousText = text.value;

    function renderSocialIcons() {
      if (!socialMode || !catalog) return;
      var selected = el("[data-vd-social-selected]");
      var picker = el("[data-vd-social-picker]");
      var add = el("[data-vd-add-social]");
      selected.replaceChildren();
      picker.replaceChildren();
      function iconButton(icon, remove) {
        var button = document.createElement("button");
        button.type = "button";
        button.style.cssText = "display:inline-flex;align-items:center;gap:8px;min-height:44px;padding:10px;margin:4px;border:1px solid #bbc0c9;border-radius:10px;background:#fff;color:#111;cursor:pointer";
        button.setAttribute("aria-label", (remove ? "Remove " : "Add ") + icon.label);
        var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("viewBox", "0 0 " + icon.width + " " + icon.height);
        svg.setAttribute("width", "24"); svg.setAttribute("height", "24"); svg.setAttribute("aria-hidden", "true");
        var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", icon.path); path.setAttribute("fill", "currentColor");
        svg.appendChild(path); button.appendChild(svg);
        button.appendChild(document.createTextNode(icon.label + (remove ? " ×" : "")));
        button.disabled = maxIcons === 1;
        button.addEventListener("click", function () {
          if (maxIcons === 1) return;
          if (remove) socialIcons = socialIcons.filter(function (id) { return id !== icon.id; });
          else if (socialIcons.length < maxIcons && socialIcons.indexOf(icon.id) < 0) socialIcons.push(icon.id);
          picker.hidden = true; add.setAttribute("aria-expanded", "false");
          renderSocialIcons(); geometryChanged();
        });
        return button;
      }
      socialIcons.forEach(function (id) {
        var icon = catalog.socialIcons.find(function (icon) { return icon.id === id; });
        if (icon) selected.appendChild(iconButton(icon, true));
      });
      catalog.socialIcons.filter(function (icon) { return socialIcons.indexOf(icon.id) < 0; }).forEach(function (icon) {
        picker.appendChild(iconButton(icon, false));
      });
      add.hidden = maxIcons === 1;
      add.disabled = socialIcons.length >= maxIcons;
      el("[data-vd-summary-social]").textContent = socialIcons.map(function (id) {
        return catalog.socialIcons.find(function (icon) { return icon.id === id; }).label;
      }).join(", ") || "None";
      add.textContent = socialIcons.length >= maxIcons ? "4 of 4 icons added" : "+ Add icon (" + socialIcons.length + "/4)";
    }

    function lineStart(inputs, index) {
      var start = fixedPrefix.length;
      for (var position = 0; position < index; position += 1) start += inputs[position].value.length + 1;
      return start;
    }
    function multilineInputs() {
      return lineInputsContainer ? Array.from(lineInputsContainer.querySelectorAll("input")) : [];
    }
    function syncMultilineText(activeInput) {
      var inputs = multilineInputs();
      var nextText = joinedText(inputs);
      text.value = nextText;
      reconcileRuns(nextText);
      if (activeInput) {
        var index = inputs.indexOf(activeInput);
        var start = lineStart(inputs, index);
        selectionStart = start + (activeInput.selectionStart || 0);
        selectionEnd = start + (activeInput.selectionEnd || activeInput.selectionStart || 0);
        selectedRanges = selectionEnd > selectionStart ? [{ start: selectionStart, end: selectionEnd }] : [];
      }
      renderSelectionState();
      geometryChanged();
    }
    function renderLineInputs(values, focusIndex) {
      if (!lineInputsContainer) return;
      lineInputsContainer.replaceChildren();
      values.forEach(function (value, index) {
        var row = document.createElement("div");
        row.className = "vd-decal__line-row";
        var label = document.createElement("label");
        var caption = document.createElement("span");
        caption.textContent = memorialMode ? ["Curved heading","Name / dedication","Dates / bottom line","Additional line 1 (+$0.50)","Additional line 2 (+$0.50)"][index] : fixedPrefix ? (fixedPrefix === "#" ? "Your hashtag (# included)" : fixedPrefix === "@" ? "Your username (@ included)" : "got ___? - fill in the blank") : letterMode ? "Capital letter" : "Line " + (index + 1);
        if (catalog && catalog.productProfile && catalog.productProfile.fieldLabels) caption.textContent = catalog.productProfile.fieldLabels[index] || caption.textContent;
        var input = document.createElement("input");
        input.type = "text";
        input.maxLength = letterMode ? 1 : catalog && catalog.productProfile && catalog.productProfile.maximumCharacters || (productHandle === "customlongquote" ? 300 : 80);
        if (letterMode) input.setAttribute("autocapitalize", "characters");
        input.value = index === 0 ? stripAffixes(value) : value;
        input.autocomplete = "off";
        input.placeholder = letterMode ? "A" : index === 0 ? "Enter your first line" : "Optional line " + (index + 1);
        label.append(caption, input);
        var style = document.createElement("button");
        style.type = "button";
        style.textContent = "Style line";
        if (letterMode) style.hidden = true;
        style.setAttribute("data-vd-style-line", "");
        style.disabled = !value;
        style.addEventListener("click", function (event) {
          var inputs = multilineInputs();
          var start = lineStart(inputs, index);
          selectRange(start, start + input.value.length, false, additiveSelection(event));
        });
        ["select", "keyup", "mouseup", "touchend", "focus"].forEach(function (eventName) {
          input.addEventListener(eventName, function () {
            var inputs = multilineInputs();
            var start = lineStart(inputs, index);
            selectionStart = start + (input.selectionStart || 0);
            selectionEnd = start + (input.selectionEnd || input.selectionStart || 0);
            selectedRanges = selectionEnd > selectionStart ? [{ start: selectionStart, end: selectionEnd }] : [];
            renderSelectionState();
          });
        });
        input.addEventListener("input", function () {
          if (letterMode) input.value = input.value.toUpperCase().replace(/[^A-Z]/g, "").slice(0, 1);
          style.disabled = !input.value;
          syncMultilineText(input);
        });
        row.append(label, style);
        lineInputsContainer.append(row);
      });
      var count = el("[data-vd-line-count]");
      if (count) count.textContent = values.length + " of " + maximumLines + " lines";
      var add = el("[data-vd-add-line]");
      var remove = el("[data-vd-remove-line]");
      if (add) add.disabled = values.length >= maximumLines;
      if (remove) remove.disabled = values.length <= (memorialMode ? 3 : 1);
      if (Number.isInteger(focusIndex)) {
        var target = multilineInputs()[focusIndex];
        if (target) target.focus();
      }
    }

    function sameRunStyle(a, b) {
      return a.fontId === b.fontId && a.sizePercent === b.sizePercent;
    }
    function compactRuns(runs, length, fallback) {
      if (!length) return [];
      var sorted = runs.map(function (run) {
        return {
          start: Math.max(0, Math.min(length, Math.round(run.start))),
          end: Math.max(0, Math.min(length, Math.round(run.end))),
          fontId: run.fontId,
          sizePercent: Math.max(50, Math.min(200, Math.round(run.sizePercent)))
        };
      }).filter(function (run) { return run.end > run.start; })
        .sort(function (a, b) { return a.start - b.start || a.end - b.end; });
      var covered = [];
      var cursor = 0;
      sorted.forEach(function (run) {
        if (run.start > cursor) covered.push(Object.assign({}, fallback, { start: cursor, end: run.start }));
        var start = Math.max(cursor, run.start);
        if (run.end > start) {
          covered.push(Object.assign({}, run, { start: start }));
          cursor = run.end;
        }
      });
      if (cursor < length) covered.push(Object.assign({}, fallback, { start: cursor, end: length }));
      return covered.reduce(function (merged, run) {
        var prior = merged[merged.length - 1];
        if (prior && prior.end === run.start && sameRunStyle(prior, run)) prior.end = run.end;
        else merged.push(Object.assign({}, run));
        return merged;
      }, []);
    }
    function runAt(index) {
      return textRuns.find(function (run) { return index >= run.start && index < run.end; }) ||
        textRuns[textRuns.length - 1] || { fontId: selectedFont.id, sizePercent: 100 };
    }
    function additiveSelection(event) {
      return Boolean(event && (event.shiftKey || event.ctrlKey || event.metaKey));
    }
    function normalizeRanges(ranges) {
      return ranges.filter(function (range) { return range.end > range.start; })
        .sort(function (a, b) { return a.start - b.start || a.end - b.end; })
        .reduce(function (merged, range) {
          var prior = merged[merged.length - 1];
          if (prior && range.start <= prior.end) prior.end = Math.max(prior.end, range.end);
          else merged.push({ start: range.start, end: range.end });
          return merged;
        }, []);
    }
    function rangeSelected(start, end) {
      return selectedRanges.some(function (range) { return range.start <= start && range.end >= end; });
    }
    function activeRanges() {
      if (selectedRanges.length) return selectedRanges.map(function (range) { return Object.assign({}, range); });
      if (selectionEnd > selectionStart) return [{ start: selectionStart, end: selectionEnd }];
      return [{ start: 0, end: text.value.length }];
    }
    function selectRange(start, end, focusInput, additive) {
      if(freeformController)freeformController.selectWord(start,end);
      var nextStart = Math.max(0, Math.min(text.value.length, start));
      var nextEnd = Math.max(nextStart, Math.min(text.value.length, end));
      if (additive && nextEnd > nextStart) {
        if (rangeSelected(nextStart, nextEnd)) {
          selectedRanges = normalizeRanges(selectedRanges.flatMap(function (range) {
            if (range.end <= nextStart || range.start >= nextEnd) return [range];
            var pieces = [];
            if (range.start < nextStart) pieces.push({ start: range.start, end: nextStart });
            if (range.end > nextEnd) pieces.push({ start: nextEnd, end: range.end });
            return pieces;
          }));
        } else {
          selectedRanges = normalizeRanges(selectedRanges.concat({ start: nextStart, end: nextEnd }));
        }
      } else {
        selectedRanges = nextEnd > nextStart ? [{ start: nextStart, end: nextEnd }] : [];
      }
      selectionStart = selectedRanges.length ? selectedRanges[0].start : 0;
      selectionEnd = selectedRanges.length ? selectedRanges[0].end : 0;
      if (focusInput) {
        text.focus();
        text.setSelectionRange(selectionStart, selectionEnd);
      }
      renderSelectionState();
    }
    function patchRunsInRange(runs, range, patch) {
      var next = [];
      runs.forEach(function (run) {
        if (run.end <= range.start || run.start >= range.end) {
          next.push(Object.assign({}, run));
          return;
        }
        if (run.start < range.start) next.push(Object.assign({}, run, { end: range.start }));
        next.push(Object.assign({}, run, patch, {
          start: Math.max(run.start, range.start),
          end: Math.min(run.end, range.end)
        }));
        if (run.end > range.end) next.push(Object.assign({}, run, { start: range.end }));
      });
      return next;
    }
    function applyStyle(patch) {
      styleHistory.push(JSON.stringify(textRuns));
      if (styleHistory.length > 20) styleHistory.shift();
      el("[data-vd-undo]").disabled = false;
      var ranges = activeRanges();
      var patches = ranges.map(function (range) {
        return typeof patch === "function" ? patch(runAt(range.start), range) : patch;
      });
      var next = textRuns.map(function (run) { return Object.assign({}, run); });
      ranges.forEach(function (range, index) { next = patchRunsInRange(next, range, patches[index]); });
      textRuns = compactRuns(next, text.value.length, textRuns[0] || {
        fontId: selectedFont.id, sizePercent: 100
      });
      renderSelectionState();
      renderFontList();
      summary();
      invalidate();
      queueRender(0);
    }
    function restoreRuns(serialized) {
      textRuns = compactRuns(JSON.parse(serialized), text.value.length, {
        fontId: catalog.fonts[0].id, sizePercent: 100
      });
      renderSelectionState();
      renderFontList();
      summary();
      invalidate();
      queueRender(0);
    }
    function reconcileRuns(nextText) {
      var fallback = textRuns[0] || { fontId: selectedFont.id, sizePercent: 100 };
      if (previousText === nextText) return;
      var prefix = 0;
      while (prefix < previousText.length && prefix < nextText.length && previousText[prefix] === nextText[prefix]) prefix += 1;
      var suffix = 0;
      while (suffix < previousText.length - prefix && suffix < nextText.length - prefix &&
        previousText[previousText.length - 1 - suffix] === nextText[nextText.length - 1 - suffix]) suffix += 1;
      var oldEnd = previousText.length - suffix;
      var newEnd = nextText.length - suffix;
      var delta = nextText.length - previousText.length;
      var inherited = runAt(Math.max(0, prefix - 1));
      var shifted = [];
      textRuns.forEach(function (run) {
        if (run.end <= prefix) shifted.push(Object.assign({}, run));
        else if (run.start >= oldEnd) shifted.push(Object.assign({}, run, { start: run.start + delta, end: run.end + delta }));
        else {
          if (run.start < prefix) shifted.push(Object.assign({}, run, { end: prefix }));
          if (run.end > oldEnd) shifted.push(Object.assign({}, run, { start: newEnd, end: run.end + delta }));
        }
      });
      if (newEnd > prefix) shifted.push(Object.assign({}, inherited, { start: prefix, end: newEnd }));
      textRuns = compactRuns(shifted, nextText.length, fallback);
      previousText = nextText;
    }
    function renderWordChips() {
      var container = el("[data-vd-word-chips]");
      container.replaceChildren();
      var pattern = productHandle === "custom-monogram" ? /[A-Za-z]/g : /\S+/g;
      var match;
      while ((match = pattern.exec(text.value))) {
        (function (word, start, end) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "vd-decal__word-chip";
          button.textContent = word;
          var wordRun = runAt(start);
          var wordFont = catalog.fonts.find(function (font) { return font.id === wordRun.fontId; });
          loadFontPreview(wordFont, button);
          button.setAttribute("aria-pressed", String(rangeSelected(start, end)));
          button.title = "Click to select. Ctrl/Command-click or Shift-click to add or remove this word.";
          button.addEventListener("click", function (event) {
            selectRange(start, end, false, additiveSelection(event));
          });
          container.append(button);
        }(match[0], match.index, match.index + match[0].length));
      }
    }
    function captureSelection() {
      selectionStart = text.selectionStart || 0;
      selectionEnd = text.selectionEnd || selectionStart;
      selectedRanges = selectionEnd > selectionStart ? [{ start: selectionStart, end: selectionEnd }] : [];
      renderSelectionState();
    }
    function renderSelectionState() {
      var hasSelection = selectedRanges.length > 0 || selectionEnd > selectionStart;
      var primaryRange = selectedRanges[0] || { start: selectionStart, end: selectionEnd };
      var run = runAt(Math.min(primaryRange.start, Math.max(0, text.value.length - 1)));
      selectedFont = catalog.fonts.find(function (font) { return font.id === run.fontId; }) || selectedFont;
      fontSize.value = String(run.sizePercent);
      el("[data-vd-selection-label]").textContent = selectedRanges.length > 1
        ? "Editing " + selectedRanges.length + " selections together - Ctrl/Command-click to add or remove words or lines."
        : hasSelection
        ? 'Editing "' + text.value.slice(primaryRange.start, primaryRange.end).replace(/\n/g, " / ") + "\" - drag across nearby text, or Ctrl/Command-click another word or line."
        : wallMode
          ? "Editing the whole quote - choose Style line or tap a word in the artwork."
          : "Editing the whole design - tap a word on the artwork to style just that word.";
      editAll.hidden = !hasSelection;
      if (lineInputsContainer) {
        var inputs = multilineInputs();
        all("[data-vd-style-line]").forEach(function (button, index) {
          var start = lineStart(inputs, index);
          var pressed = Boolean(inputs[index] && rangeSelected(start, start + inputs[index].value.length));
          button.setAttribute("aria-pressed", String(pressed));
        });
      }
      renderWordChips();
      if (currentPreview) renderPreviewWordTargets(currentPreview);
    }

    function selectedMaterial() {
      return all("[data-vd-material]").find(function (input) { return input.checked; }).value;
    }
    function maximumWallHeight() {
      if (!wallMode || !catalog || !catalog.maximumHeightByMaterial) return 163;
      return Number(catalog.maximumHeightByMaterial[selectedMaterial()]) || 48;
    }
    function syncDimensionLimits() {
      if (boatMode) { widthInput.value=el("[data-vd-boat-size]").value; heightInput.value=productHandle==="cujetskirenu"||widthInput.value==="22"?"3":"4"; return; }
      if (fixedPair) { el("[data-vd-wall-limits]").textContent="Fixed at 8 inches wide × 2 inches tall. Each pair contains two identical decals."; return; }
      if (!wallMode || !catalog) return;
      widthInput.max=String(Math.min(Number(catalog.maximumWidthInches)||150,catalog.productProfile&&catalog.productProfile.maximumWidth||150,catalog.pricingProfile&&catalog.pricingProfile.max||150));
      heightInput.max=String(Math.min(150,catalog.productProfile&&catalog.productProfile.maximumHeight||150));
      var limits=el("[data-vd-wall-limits]");
      if(limits)limits.textContent="One-piece material height: "+maximumWallHeight()+"″. Taller designs ship in multiple sections and are priced per roll pass. Finished dimensions remain unchanged.";
    }
    function sectionNotice() {
      var notice=el('[data-vd-section-notice]');
      if(!notice){notice=document.createElement('p');notice.dataset.vdSectionNotice='';notice.setAttribute('role','status');notice.style.cssText='padding:14px;border:1px solid #d39922;border-radius:10px;background:#fff6dc;color:#422d00;font-weight:600';approval.parentElement.insertAdjacentElement('beforebegin',notice);}
      var pricing=currentPreview&&currentPreview.pricing;
      notice.hidden=!(pricing&&pricing.sectionCount>1);
      notice.textContent=pricing&&pricing.sectionCount>1?pricing.sectionNotice+' '+pricing.sectionCount+'× section pricing is included in the total.':'';
    }
    function addSectionProperties(approved,properties) {
      if(approved.sectionPricingVersion!=='roll-v1')return;
      properties['_VD Decal Section Pricing']='roll-v1';
      properties['_VD Decal Section Count']=String(approved.sectionCount);
      properties['_VD Decal Roll Height']=String(approved.rollHeightInches);
      if(approved.sectionCount>1)properties['Delivery sections']=approved.sectionNotice;
    }
    function reversed() {
      return all("[data-vd-reversed]").find(function (input) { return input.checked; }).value === "true";
    }
    function syncReverseAvailability() {
      var disabled = boatMode || selectedMaterial() === "Specialty Colors" || selectedMaterial() === "Heat Transfer";
      var changed = disabled && reversed();
      if (changed) {
        all("[data-vd-reversed]").forEach(function (input) {
          input.checked = input.value === "false";
        });
      }
      all("[data-vd-reversed]").forEach(function (input) { input.disabled = disabled; });
      reverseField.hidden = disabled;
      reverseSummaryRow.hidden = disabled;
      return changed;
    }
    function selectedSize() {
      var requested = currentPreview ? (verticalMode ? currentPreview.heightInches : wallMode ? currentPreview.widthInches : Math.max(currentPreview.widthInches, currentPreview.heightInches)) : Number(widthInput.value);
      return catalog.sizes.find(function (option) { return option.lengthInches >= requested; });
    }
    function selectedColor() {
      return catalog.colors.find(function (entry) { return entry.label === color.value; });
    }
    function effectivePriceCents() {
      return currentPreview && currentPreview.pricing && currentPreview.pricing.status === "priced" ?
        currentPreview.pricing.priceCents : 0;
    }
    function selectedBulkRate() {
      var requested = Math.max(1, Math.min(1000, Number(quantity.value) || 1));
      return catalog.bulkRates.slice().reverse().find(function (rate) {
        return requested >= rate.minimumQuantity;
      }) || catalog.bulkRates[0];
    }
    function renderColors() {
      var material = selectedMaterial();
      var prior = color.value;
      color.replaceChildren();
      catalog.colors.filter(function (entry) {
        return entry.materials.indexOf(material) >= 0;
      }).forEach(function (entry) {
        var item = document.createElement("option");
        item.value = entry.label;
        item.textContent = entry.label + (entry.priceMultiplier === 2 ? " - Specialty 2×" : "");
        color.append(item);
      });
      if (Array.from(color.options).some(function (item) { return item.value === prior; })) color.value = prior;
    }
    function renderPreviewWordTargets(preview) {
      if(freeformController){previewWords.replaceChildren();freeformController.update(preview);return;}
      previewWords.replaceChildren();
      if (!preview || !text.value.length) return;
      (preview.lineTargets || []).forEach(function (target) {
        var rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        rect.setAttribute("x", String(target.x));
        rect.setAttribute("y", String(target.y));
        rect.setAttribute("width", String(target.width));
        rect.setAttribute("height", String(target.height));
        rect.setAttribute("class", "vd-decal__line-target" +
          (rangeSelected(target.start, target.end) ? " is-selected" : ""));
        rect.setAttribute("role", "button");
        rect.setAttribute("tabindex", "0");
        rect.setAttribute("aria-label", "Style line " + (target.lineIndex + 1));
        rect.addEventListener("click", function (event) { selectRange(target.start, target.end, false, additiveSelection(event)); });
        rect.addEventListener("keydown", function (event) {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            selectRange(target.start, target.end, false, additiveSelection(event));
          }
        });
        previewWords.append(rect);
      });
      (preview.wordTargets || []).forEach(function (target) {
        (function (word, start, end, x, width, y, height) {
          var padding = Math.min(0.08, preview.widthInches * 0.01);
          x = Math.max(0, x - padding);
          width = Math.min(preview.widthInches - x, width + padding * 2);
          var rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
          rect.setAttribute("x", String(x));
          rect.setAttribute("y", String(y));
          rect.setAttribute("width", String(width));
          rect.setAttribute("height", String(height));
          rect.setAttribute("class", "vd-decal__word-target" +
            (rangeSelected(start, end) ? " is-selected" : ""));
          rect.setAttribute("role", "button");
          rect.setAttribute("tabindex", "0");
          rect.setAttribute("aria-label", 'Edit word "' + word + '"');
          rect.addEventListener("click", function (event) { selectRange(start, end, false, additiveSelection(event)); });
          rect.addEventListener("keydown", function (event) {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              selectRange(start, end, false, additiveSelection(event));
            }
          });
          previewWords.append(rect);
          if (rangeSelected(start, end)) {
            var handle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            handle.setAttribute("cx", String(x + width));
            handle.setAttribute("cy", String(y + height / 2));
            handle.setAttribute("r", String(Math.max(0.045, Math.min(0.11, height * 0.12))));
            handle.setAttribute("class", "vd-decal__resize-handle");
            handle.setAttribute("role", "slider");
            handle.setAttribute("aria-label", "Drag to resize selected word without overlapping adjacent words");
            handle.addEventListener("pointerdown", function (event) {
              event.preventDefault();
              var startX = event.clientX;
              var startSize = Number(fontSize.value);
              handle.setPointerCapture(event.pointerId);
              handle.addEventListener("pointerup", function finish(upEvent) {
                var svgWidth = el("[data-vd-preview]").getBoundingClientRect().width || 1;
                var change = Math.round((upEvent.clientX - startX) / svgWidth * 200 / 10) * 10;
                var nextSize = Math.max(50, Math.min(200, startSize + change));
                fontSize.value = String(nextSize);
                applyStyle({ sizePercent: nextSize });
                handle.removeEventListener("pointerup", finish);
              });
            });
            previewWords.append(handle);
          }
        }(text.value.slice(target.start, target.end), target.start, target.end, target.x, target.width, target.y, target.height));
      });
    }
    function showError(message) {
      error.textContent = message;
      error.hidden = !message;
    }
    function setBusy(value) {
      root.setAttribute("aria-busy", String(value));
      el("[data-vd-updating]").hidden = !value;
    }
    function invalidate() {
      currentPreview = null;
      approval.checked = false;
      approval.disabled = true;
      submit.disabled = true;
    }
    function updateApprovalState() {
      var priced = currentPreview && currentPreview.pricing && currentPreview.pricing.status === "priced";
      var distortionReady = fixedPair || !currentPreview || !currentPreview.distorted ||
        (distortionAccepted && distortionAck.checked);
      approval.disabled = !priced || !distortionReady || (fixedPrefix && !stripAffixes(text.value).trim());
      if (!priced || !distortionReady) approval.checked = false;
      manualChoice.disabled = approval.disabled;
      submit.disabled = submitting || approval.disabled || (manualChoice.checked ? !manualNotes.value.trim() : !approval.checked);
      submit.textContent = manualChoice.checked ? "Add to cart - request manual proof" : "Approve Design & Add to Cart";
    }
    function summary() {
      sectionNotice();
      var priceCents = effectivePriceCents();
      el("[data-vd-summary-text]").textContent = wallMode ?
        text.value.split("\n").filter(Boolean).join(" / ") || "-" : text.value || "-";
      el("[data-vd-summary-color]").textContent = color.value;
      var material = selectedMaterial();
      el("[data-vd-summary-material]").textContent = material.startsWith("Outdoor") ? "Outdoor" :
        material.startsWith("Indoor") ? "Indoor" : material;
      el("[data-vd-summary-reversed]").textContent = reversed() ? "Yes" : "No";
      var discount = selectedBulkRate().discountPercent;
      el("[data-vd-discount-row]").hidden = !discount;
      el("[data-vd-summary-discount]").textContent = discount ? discount + "% off" : "";
      if (memorialMode) {
        var bulkCents = currentPreview && currentPreview.pricing ? Number(currentPreview.pricing.discountCents || 0) : 0;
        el("[data-vd-discount-row]").hidden = !bulkCents;
        el("[data-vd-summary-discount]").textContent = money(bulkCents) + " off each";
      }
      el("[data-vd-summary-price]").textContent = priceCents ? money(priceCents) :
        currentPreview && currentPreview.pricing ? "Custom quote required" : "-";
      el("[data-vd-summary-total]").textContent = priceCents ? money(priceCents * Math.max(1, Number(quantity.value) || 1)) : "-";
      if (catalog && textRuns.length) {
        var families = Array.from(new Set(textRuns.map(function (run) {
          var face = catalog.fonts.find(function (font) { return font.id === run.fontId; });
          return face ? face.family : run.fontId;
        })));
        el("[data-vd-summary-font]").textContent = families.join(" + ");
      }
    }
    function renderFontList() {
      if(freeformController){var key=JSON.stringify([text.value,selectedFont&&selectedFont.id,selectedCategory,fontListExpanded,search.value]);if(key===freeformFontListKey)return;freeformFontListKey=key;}
      var query = search.value.trim().toLowerCase();
      var fonts = catalog.fonts.filter(function (font) {
        return (!query || font.family.toLowerCase().includes(query)) &&
          (selectedCategory === "all" || font.categories.includes(selectedCategory));
      });
      var fontMore = el("[data-vd-font-more]");
      var hasIntentionalFilter = Boolean(query) || selectedCategory !== "all";
      var visibleFonts = fontListExpanded || hasIntentionalFilter ? fonts : fonts.slice(0, 36);
      fontMore.hidden = visibleFonts.length === fonts.length;
      fontMore.textContent = "Show all " + fonts.length + " fonts";
      var list = el("[data-vd-font-list]");
      list.replaceChildren();
      if (fontObserver) fontObserver.disconnect();
      fontObserver = window.IntersectionObserver ? new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var font = catalog.fonts.find(function (candidate) { return candidate.id === entry.target.dataset.fontId; });
          loadFontPreview(font, entry.target.querySelector(".vd-decal__font-sample"));
          fontObserver.unobserve(entry.target);
        });
      }, { root: list, rootMargin: "160px" }) : null;
      visibleFonts.forEach(function (font) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "vd-decal__font-card";
        button.dataset.fontId = font.id;
        button.setAttribute("role", "option");
        button.setAttribute("aria-selected", String(selectedFont && selectedFont.id === font.id));
        var body = document.createElement("span");
        var sample = document.createElement("span");
        sample.className = "vd-decal__font-sample";
        sample.textContent = text.value || "Your text";
        var name = document.createElement("span");
        name.className = "vd-decal__font-name";
        name.textContent = font.family + " - Engineering preview";
        body.append(sample, name);
        var check = document.createElement("span");
        check.className = "vd-decal__font-check";
        check.textContent = selectedFont && selectedFont.id === font.id ? "Selected" : "";
        button.append(body, check);
        if (fontObserver) fontObserver.observe(button);
        else if (list.children.length < 12) loadFontPreview(font, sample);
        button.addEventListener("click", function () {
          selectedFont = font;
          applyStyle({ fontId: font.id });
        });
        list.append(button);
      });
    }
    function renderCategories() {
      var categoryValues = catalog.fonts.reduce(function (values, font) {
        return values.concat(font.categories);
      }, []);
      var categories = ["all"].concat(Array.from(new Set(categoryValues)));
      var container = el("[data-vd-categories]");
      container.replaceChildren();
      categories.forEach(function (category) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "vd-decal__category";
        button.textContent = category;
        button.setAttribute("aria-pressed", String(category === selectedCategory));
        button.addEventListener("click", function () {
          selectedCategory = category;
          fontListExpanded = false;
          renderCategories();
          renderFontList();
        });
        container.append(button);
      });
    }
    function renderInput() {
      return {freeform:freeformController?freeformController.value():undefined,
        socialIcons: socialMode ? socialIcons.slice() : undefined,
        text: boatMode ? text.value.replace(/\s/g, "").toUpperCase().replace(/^(.{2})(.{4})(.{2})$/, "$1  $2  $3") : text.value,
        fontId: selectedFont.id,
        runs: boatMode ? undefined : textRuns,
        drumDiameter: drumMode ? Number(el("[data-vd-drum-size]").value) : undefined,
        lengthInches: fixedPair ? 8 : Number(widthInput.value),
        widthInches: fixedPair ? 8 : Number(widthInput.value),
        heightInches: fixedPair ? 2 : Number(heightInput.value),
        proportionsLocked: fixedPair || boatMode ? false : proportionsLocked,
        sizingBasis: sizingBasis,
        distortionAcknowledged: distortionAck.checked,
        reversed: reversed(),
        vinylColor: color.value,
        material: selectedMaterial(),
        quantity: Math.max(1, Math.min(1000, Math.round(Number(quantity.value) || 1))),
        productId: productId,
        variantId: variantId,
        productHandle: productHandle, sectionPricingVersion: wallMode ? "roll-v1" : undefined
      };
    }

    // Deterministic reference-only fallback: no canvas, font loading or pixel-read APIs.
    function basicReferencePng(value) {
      var glyphs = {
        'A':[14,17,17,31,17,17,17],'B':[30,17,17,30,17,17,30],'C':[14,17,16,16,16,17,14],
        'D':[30,17,17,17,17,17,30],'E':[31,16,16,30,16,16,31],'F':[31,16,16,30,16,16,16],
        'G':[14,17,16,23,17,17,15],'H':[17,17,17,31,17,17,17],'I':[31,4,4,4,4,4,31],
        'J':[7,2,2,2,18,18,12],'K':[17,18,20,24,20,18,17],'L':[16,16,16,16,16,16,31],
        'M':[17,27,21,21,17,17,17],'N':[17,25,21,19,17,17,17],'O':[14,17,17,17,17,17,14],
        'P':[30,17,17,30,16,16,16],'Q':[14,17,17,17,21,18,13],'R':[30,17,17,30,20,18,17],
        'S':[15,16,16,14,1,1,30],'T':[31,4,4,4,4,4,4],'U':[17,17,17,17,17,17,14],
        'V':[17,17,17,17,17,10,4],'W':[17,17,17,21,21,21,10],'X':[17,17,10,4,10,17,17],
        'Y':[17,17,10,4,4,4,4],'Z':[31,1,2,4,8,16,31],
        '0':[14,17,19,21,25,17,14],'1':[4,12,4,4,4,4,14],'2':[14,17,1,2,4,8,31],
        '3':[30,1,1,14,1,1,30],'4':[2,6,10,18,31,2,2],'5':[31,16,16,30,1,1,30],
        '6':[14,16,16,30,17,17,14],'7':[31,1,2,4,8,8,8],'8':[14,17,17,14,17,17,14],
        '9':[14,17,17,15,1,1,14],' ':[0,0,0,0,0,0,0],"'":[4,4,8,0,0,0,0],
        '.':[0,0,0,0,0,12,12],',':[0,0,0,0,4,4,8],'-':[0,0,0,31,0,0,0],
        '?':[14,17,1,2,4,0,4],'!':[4,4,4,4,4,0,4],':':[0,4,4,0,4,4,0],
        '/':[1,2,2,4,8,8,16],'&':[12,18,20,8,21,18,13],'@':[14,17,23,21,23,16,14],
        '#':[10,31,10,10,31,10,0],'_':[0,0,0,0,0,0,31],'+':[0,4,4,31,4,4,0],
        '(':[2,4,8,8,8,4,2],')':[8,4,2,2,2,4,8]
      };
      var label=String(value).toUpperCase().replace(/[‘’]/g,"'").replace(/[–—]/g,'-');
      // Never silently substitute unsupported characters; full original text remains on the cart/order.
      if(Array.from(label).some(function(c){return c!=='\n'&&!glyphs[c];}))label='SEE ORDER TEXT';
      var lines=[]; label.split('\n').forEach(function(line){for(var p=0;p<line.length;p+=38)lines.push(line.slice(p,p+38));});
      if(!lines.length)lines=['SEE ORDER TEXT'];
      var width=600,height=Math.max(360,lines.length*28+100),raw=new Uint8Array((width+1)*height); raw.fill(255);
      for(var y=0;y<height;y++)raw[y*(width+1)]=0;
      function draw(line,top,scale){var left=Math.floor((width-(line.length*6-1)*scale)/2);
        Array.from(line).forEach(function(c,index){(glyphs[c]||glyphs[' ']).forEach(function(bits,row){for(var col=0;col<5;col++)if(bits&(1<<(4-col)))for(var dy=0;dy<scale;dy++)for(var dx=0;dx<scale;dx++)raw[(top+row*scale+dy)*(width+1)+1+left+(index*6+col)*scale+dx]=0;});});}
      var scale=Math.max(1,Math.min(8,Math.floor(560/(Math.max.apply(null,lines.map(function(line){return line.length;}))*6))));
      lines.forEach(function(line,index){draw(line,Math.floor((height-70-lines.length*scale*9)/2)+index*scale*9,scale);});
      draw('TEXT REFERENCE - NOT APPROVED',height-40,2);
      function u32(n){return [n>>>24,(n>>>16)&255,(n>>>8)&255,n&255];}
      function crc(bytes){var c=0xffffffff;bytes.forEach(function(b){c^=b;for(var k=0;k<8;k++)c=(c>>>1)^((c&1)?0xedb88320:0);});return (c^0xffffffff)>>>0;}
      function chunk(type,data){var body=Array.from(type,function(c){return c.charCodeAt(0);}).concat(Array.from(data));return u32(data.length).concat(body,u32(crc(body)));}
      var z=[120,1],a=1,b=0;
      for(var offset=0;offset<raw.length;offset+=65535){var length=Math.min(65535,raw.length-offset);z.push(offset+length===raw.length?1:0,length&255,length>>>8,(~length)&255,((~length)>>>8)&255);for(var j=offset;j<offset+length;j++){z.push(raw[j]);a=(a+raw[j])%65521;b=(b+a)%65521;}}
      z.push.apply(z,u32((b<<16)|a));
      var png=[137,80,78,71,13,10,26,10].concat(chunk('IHDR',u32(width).concat(u32(height),[8,0,0,0,0])),chunk('IDAT',z),chunk('IEND',[]));
      var binary='';for(var start=0;start<png.length;start+=8192)binary+=String.fromCharCode.apply(null,png.slice(start,start+8192));
      return 'data:image/png;base64,'+btoa(binary);
    }
    function manualReferencePng(value) {
      try { return canvasManualReferencePng(value); }
      catch (problem) { return basicReferencePng(value); }
    }
    function canvasManualReferencePng(value) {
      var canvas = document.createElement("canvas");
      canvas.width = 1000; canvas.height = 600;
      var context = canvas.getContext("2d");
      if (!context) throw new Error("Could not create a reference image. Please try again.");
      context.fillStyle = "#fff"; context.fillRect(0, 0, 1000, 600);
      var lines = String(value).split("\n").filter(function(line){return line.trim();});
      var size = Math.min(100, 340 / Math.max(1, lines.length));
      function font(){context.font = "bold " + size + "px Arial, sans-serif";}
      font();
      var widest = Math.max.apply(null, lines.map(function(line){return context.measureText(line).width;}));
      if(widest > 900){size *= 900 / widest; font();}
      context.fillStyle = "#111"; context.textAlign = "center"; context.textBaseline = "middle";
      lines.forEach(function(line,index){context.fillText(line,500,280+(index-(lines.length-1)/2)*size*1.3);});
      // Verify actual text pixels, not merely a successfully encoded empty image.
      var pixels=context.getImageData(0,30,1000,470).data, ink=0;
      for(var i=0;i<pixels.length;i+=4){if(pixels[i]<100&&pixels[i+3]>200)ink++;}
      if(ink<20)throw new Error("Could not draw your reference text. Please try again.");
      context.font="bold 28px Arial, sans-serif";
      context.fillText("TEXT REFERENCE - NOT AN APPROVED DESIGN",500,540);
      return canvas.toDataURL("image/png");
    }
    function previewPng(previewSnapshot) {
      return new Promise(function (resolve, reject) {
        if (!previewSnapshot) {
          reject(new Error("Review the latest preview before approval"));
          return;
        }
        var svgMarkup = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
          previewSnapshot.viewBox + '"><rect width="100%" height="100%" fill="#fff"/><path d="' +
          previewSnapshot.path + '" fill="#000"/></svg>';
        var objectUrl = URL.createObjectURL(new Blob([svgMarkup], { type: "image/svg+xml" }));
        var image = new Image();
        image.onload = function () {
          URL.revokeObjectURL(objectUrl);
          var width = 1200;
          var height = Math.max(1, Math.min(1200, Math.round(width * previewSnapshot.heightInches / previewSnapshot.widthInches)));
          var canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          var context = canvas.getContext("2d");
          context.fillStyle = "#fff";
          context.fillRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          canvas.toBlob(function (blob) {
            if (!blob) {
              reject(new Error("Could not create the production preview"));
              return;
            }
            var reader = new FileReader();
            reader.onload = function () { resolve(String(reader.result)); };
            reader.onerror = function () { reject(new Error("Could not read the production preview")); };
            reader.readAsDataURL(blob);
          }, "image/png");
        };
        image.onerror = function () {
          URL.revokeObjectURL(objectUrl);
          reject(new Error("Could not rasterize the production preview"));
        };
        image.src = objectUrl;
      });
    }
    async function authoritativeRender(ownRequest) {
      if (!text.value.trim() || !selectedFont) {
        if (ownRequest === requestNumber) setBusy(false);
        return;
      }
      setBusy(true);
      showError("");
      try {
        var response = await designerFetch(api + "/render", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(renderInput())
        });
        var result = await response.json();
        if (!response.ok) throw new Error(result.error || "Artwork rendering failed");
        if (ownRequest !== requestNumber) return;
        if(freeformController&&!result.freeform)throw new Error("Please refresh the page before ordering; the shape designer is not available.");
        currentPreview = result;
        var svg = el("[data-vd-preview]");
        svg.setAttribute("viewBox", result.viewBox);
        el("[data-vd-preview-path]").setAttribute("d", result.path);
        renderPreviewWordTargets(result);
        var dimensions = result.widthInches.toFixed(3) + '" x ' + result.heightInches.toFixed(3) + '"';
        el("[data-vd-finished-size]").textContent = dimensions;
        if (!wallMode || sizingBasis === "height") widthInput.value = result.widthInches.toFixed(3);
        heightInput.value = result.heightInches.toFixed(3);
        el("[data-vd-summary-width]").textContent = result.widthInches.toFixed(3) + '"';
        el("[data-vd-summary-height]").textContent = result.heightInches.toFixed(3) + '"';
        el("[data-vd-summary-proportions]").textContent = freeformController ? "Free-positioned layout" : wallMode ?
          (result.distorted ? "Custom / Centered lines" : "Locked / Centered lines") :
          result.distorted ? "Custom" : "Locked / Original Ratio";
        el("[data-vd-length-label]").textContent = result.widthInches.toFixed(3) + '"';
        el("[data-vd-height-label]").textContent = result.heightInches.toFixed(3) + '"';
        var warning = el("[data-vd-distortion]");
        warning.hidden = fixedPair || !result.distorted;
        el("[data-vd-distortion-approval]").hidden = fixedPair || !result.distorted;
        if (result.distorted) {
          var direction = result.distortionPercent >= 0 ? "vertically" : "horizontally";
          el("[data-vd-distortion-copy]").textContent = "Requested " + dimensions + ". Artwork is stretched " + direction + " by approximately " + Math.abs(result.distortionPercent).toFixed(1) + "%.";
          el("[data-vd-size-state]").textContent = fixedPair ? "✓ Stretched to exactly 8″ × 2″ - two decals per pair" : "⚠ Custom proportions";
        } else {
          distortionAccepted = false;
          distortionAck.checked = false;
          el("[data-vd-size-state]").textContent = wallMode ?
            "✓ Complete quote fitted proportionally to the selected length" :
            "✓ Original proportions maintained";
        }
        if (result.pricing && result.pricing.status !== "priced") {
          el("[data-vd-size-state]").textContent += " - " + result.pricing.reason;
        }
        updateApprovalState();
        renderFontList();
        summary();
        specialPreview(result);
      } catch (problem) {
        showError(problem instanceof Error ? problem.message : "Artwork rendering failed");
      } finally {
        if (ownRequest === requestNumber) setBusy(false);
      }
    }
    function queueRender(delay) {
      clearTimeout(timer);
      var queuedRequest = ++requestNumber;
      timer = setTimeout(function () {
        authoritativeRender(queuedRequest);
      }, delay === undefined ? 350 : delay);
    }
    function geometryChanged() {
      invalidate();
      renderFontList();
      queueRender();
    }
    async function refreshPricing() {
      if (!currentPreview) return;
      var ownRequest = ++quoteRequestNumber;
      approval.checked = false;
      approval.disabled = true;
      submit.disabled = true;
      try {
        var response = await designerFetch(api + "/quote", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            lengthInches: Number(widthInput.value),
            text: text.value,
            widthInches: currentPreview.widthInches,
            heightInches: currentPreview.heightInches,
            distorted: currentPreview.distorted,
            vinylColor: color.value,
            material: selectedMaterial(),
            quantity: Math.max(1, Math.min(1000, Math.round(Number(quantity.value) || 1))),
            productId: productId,
            variantId: variantId,
            productHandle: productHandle, sectionPricingVersion: wallMode ? "roll-v1" : undefined
          })
        });
        var result = await response.json();
        if (!response.ok) throw new Error(result.error || "Price update failed");
        if (ownRequest !== quoteRequestNumber || !currentPreview) return;
        currentPreview.pricing = result.pricing;
        showError("");
        summary();
        updateApprovalState();
      } catch (problem) {
        if (ownRequest !== quoteRequestNumber) return;
        showError(problem instanceof Error ? problem.message : "Price update failed");
      }
    }
    function queueQuote() {
      clearTimeout(quoteTimer);
      if (currentPreview) currentPreview.pricing = null;
      approval.checked = false;
      approval.disabled = true;
      submit.disabled = true;
      summary();
      quoteTimer = setTimeout(refreshPricing, 180);
    }
    async function approveAndAdd() {
      if (submitting || (!approval.checked && !manualChoice.checked) || !currentPreview || submit.disabled) return;
      var isManual = manualChoice.checked;
      var notesSnapshot = isManual ? manualNotes.value.trim() : "";
      if (isManual && !notesSnapshot) return;
      if (!currentPreview.pricing || currentPreview.pricing.status !== "priced") {
        showError(currentPreview.pricing ? currentPreview.pricing.reason : "A verified price is unavailable for this design.");
        return;
      }
      var option = selectedSize();
      if (!option) {
        showError("This size needs a custom quote before it can be ordered online.");
        return;
      }
      var previewSnapshot = currentPreview;
      var inputSnapshot = renderInput();
      var fontFamily = Array.from(new Set(previewSnapshot.runs.map(function (run) { return run.fontFamily; }))).join(" + ");
      var vinylColor = color.value;
      var manufacturingMaterial = selectedMaterial();
      var quantitySnapshot = Math.max(1, Math.min(1000, Math.round(Number(quantity.value) || 1)));
      submitting = true;
      setBusy(true);
      submit.disabled = true;
      submit.textContent = isManual ? "Saving your proof request..." : "Validating Production PDF...";
      showError("");
      try {
        var png = isManual&&!freeformController ? manualReferencePng(inputSnapshot.text) : await previewPng(previewSnapshot);
        var approveResponse = await fetch(api + "/approve", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(Object.assign({}, inputSnapshot, {
            fingerprint: previewSnapshot.fingerprint,
            previewPng: png,
            vinylColor: vinylColor,
            material: manufacturingMaterial,
            quantity: quantitySnapshot,
            proofStatus: isManual ? "manual" : "approved",
            proofNotes: notesSnapshot
          }))
        });
        var approved = await approveResponse.json();
        if (!approveResponse.ok || approved.pdfValidation !== "PASS" || !approved.pdfUrl || approved.approvalStatus !== (isManual ? "MANUAL PROOF REQUIRED" : "APPROVED")) {
          throw new Error(approved.error || "Production PDF validation failed");
        }
        if (!currentPreview || currentPreview.fingerprint !== previewSnapshot.fingerprint ||
            JSON.stringify(renderInput()) !== JSON.stringify(inputSnapshot) ||
            color.value !== vinylColor || selectedMaterial() !== manufacturingMaterial || manualChoice.checked !== isManual || (isManual && manualNotes.value.trim() !== notesSnapshot)) {
          throw new Error("The design changed during approval. Review and approve it again.");
        }
        var properties = {
          "_VD Decal Schema": approved.schema,
          "_VD Decal Artwork ID": approved.artworkId,
          "_VD Decal Revision": String(approved.revision),
          "_VD Decal Approval Hash": approved.approvalHash,
          "_VD Decal Authorization": approved.authorization,
          "_VD Decal PDF SHA256": approved.pdfSha256,
          "_VD Decal Preview SHA256": approved.previewSha256,
          "_VD Decal Text Runs": JSON.stringify(inputSnapshot.runs),
          "_VD Decal Requested Length": (previewSnapshot.pricingLengthInches || (memorialMode ? previewSnapshot.widthInches : Math.max(previewSnapshot.widthInches, previewSnapshot.heightInches))).toFixed(6),
          "_VD Decal Requested Width": previewSnapshot.widthInches.toFixed(3),
          "_VD Decal Requested Height": previewSnapshot.heightInches.toFixed(3),
          "_VD Decal Vinyl Color": vinylColor,
          "_VD Decal Material": manufacturingMaterial,
          "_VD Decal Price Cents": String(approved.priceCents),
          "_VD Decal Quantity": String(quantitySnapshot),
          "_VD Decal API Version": wallMode ? "v3" : "v2",
          "_CHAMELEON PDF URL": approved.pdfUrl,
          "Artwork Approval": approved.approvalStatus,
          "_CHAMELEON Preview URL": approved.previewUrl,
          "_CHAMELEON Preview Alt": "Preview of custom " + (wallMode ? "wall quote: " : "text decal: ") + inputSnapshot.text.replace(/\n/g, " / "),
          "Custom Text": inputSnapshot.text,
          "Social Icons": socialMode ? inputSnapshot.socialIcons.map(function (id) {
            return catalog.socialIcons.find(function (icon) { return icon.id === id; }).label;
          }).join(", ") || "None" : "",
          "Font": fontFamily,
          "Finished Size": approved.finishedSize.widthInches.toFixed(3) + '" x ' + approved.finishedSize.heightInches.toFixed(3) + '"',
          "Proportions": previewSnapshot.distorted ? "Custom" : "Original Ratio",
          "Vinyl Color": vinylColor,
          "Material": manufacturingMaterial.startsWith("Outdoor") ? "Outdoor" :
            manufacturingMaterial.startsWith("Indoor") ? "Indoor" : manufacturingMaterial,
          "Reversed": inputSnapshot.reversed ? "Yes" : "No",
          "Pieces per set": String(fixedPair || boatMode ? 2 : option.pieces)
        };
        if (wallMode) {
          if (drumMode) properties["Drum head diameter"] = inputSnapshot.drumDiameter + " inches";
          inputSnapshot.text.split("\n").forEach(function (value, index) {
            if (value) properties["Line " + (index + 1)] = value;
          });
        }
        properties["Proof status"] = isManual ? "Not approved — manual proof requested" : "APPROVED";
        if (isManual) {
          properties["Manual proof request"] = notesSnapshot;
          properties["_VD Decal Production Hold"] = "Awaiting customer approval of revised proof";
          properties["_VD Decal Reference PDF"] = approved.pdfUrl;
          delete properties["Artwork Approval"];
          delete properties["_CHAMELEON PDF URL"];
        }
        addSectionProperties(approved,properties);
        var cartResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: Number(variantId), quantity: quantitySnapshot, properties: properties })
        });
        var line = await cartResponse.json();
        if (!cartResponse.ok) throw new Error(line.description || "Shopify could not add the approved decal");

        var verifyResponse = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
        var cart = await verifyResponse.json();
        var verified = verifyResponse.ok && cart.items && cart.items.find(function (item) {
          var itemProperties = item.properties || {};
          return String(item.id) === String(variantId) &&
            itemProperties["_VD Decal Artwork ID"] === approved.artworkId &&
            itemProperties["_VD Decal Revision"] === String(approved.revision) &&
            itemProperties["_VD Decal Approval Hash"] === approved.approvalHash &&
            itemProperties["_VD Decal Authorization"] === approved.authorization &&
            itemProperties[isManual ? "_VD Decal Reference PDF" : "_CHAMELEON PDF URL"] === approved.pdfUrl &&
            (isManual ? itemProperties["Proof status"] === "Not approved — manual proof requested" : itemProperties["Artwork Approval"] === "APPROVED") &&
            (!isManual || itemProperties["Manual proof request"] === notesSnapshot) &&
            itemProperties["_CHAMELEON Preview URL"] === approved.previewUrl &&
            Number(item.final_price) === Number(approved.priceCents);
        });
        if (!verified) {
          if (line && line.key) {
            await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", "Accept": "application/json" },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
          }
          throw new Error("Shopify cart verification failed; the unverified line was removed.");
        }
        window.location.assign("/cart");
      } catch (problem) {
        submitting = false;
        showError(problem instanceof Error ? problem.message : "Unable to add approved artwork");
        setBusy(false);
        updateApprovalState();
      }
    }

    if (wallMode) renderLineInputs(text.value.split("\n"));

    designerFetch(api + "/catalog?productHandle=" + encodeURIComponent(productHandle)).then(function (response) {
      if (!response.ok) throw new Error("Designer catalog is unavailable");
      return response.json();
    }).then(function (result) {
      catalog = result;
      if (memorialMode) {
        widthInput.value = "8"; widthInput.hidden = true;
        heightInput.disabled = true; lockButton.hidden = true;
        var sizeSelect = document.createElement("select");
        sizeSelect.setAttribute("aria-label","Memorial length in inches");
        catalog.sizes.forEach(function(size){
          var option=document.createElement("option");
          option.value=String(size.lengthInches);
          option.textContent=size.lengthInches+' inches';
          sizeSelect.append(option);
        });
        widthInput.parentNode.insertBefore(sizeSelect,widthInput);
        sizeSelect.addEventListener("change",function(){widthInput.value=sizeSelect.value;geometryChanged();});
        all("[data-vd-quick-size]").forEach(function(button){button.hidden=true;});
        all("[data-vd-material]").forEach(function(input){
          var allowed=catalog.materials.indexOf(input.value)>=0;
          input.disabled=!allowed;input.closest("label").hidden=!allowed;
        });
        el("[data-vd-add-line]").textContent="+ Add optional line (+$0.50)";
        var bulkHelp = document.createElement("small");
        bulkHelp.textContent = "Save $0.10 per decal for each 10 ordered, up to $1.00 off each at 100+.";
        quantity.parentNode.append(bulkHelp);
      }
      if (verticalMode) {
        sizingBasis = "height"; heightInput.value = "12"; proportionsLocked = true;
        widthInput.disabled = true; lockButton.hidden = true;
        all("[data-vd-quick-size]").forEach(function(button){button.hidden=true;});
      }
      if (productHandle === "customlongquote") { widthInput.value = "15"; widthInput.min = "15"; }
      if (drumMode) { heightInput.disabled = true; lockButton.hidden = true; }
      if (boatMode) {
        el(".vd-decal__text-style").hidden = true;
        widthInput.value = "22"; heightInput.value = "3"; proportionsLocked = false;
        widthInput.disabled = true; heightInput.disabled = true; lockButton.hidden = true;
        all("[data-vd-quick-size]").forEach(function(button){button.hidden=true;});
        all("[data-vd-material]").forEach(function(input){
          var allowed = input.value === "Outdoor Material (Cars)" || input.value === "Specialty Colors";
          input.disabled = !allowed; input.closest("label").hidden = !allowed;
          input.checked = input.value === "Outdoor Material (Cars)";
        });
        el("[data-vd-boat-size]").addEventListener("change",function(){syncDimensionLimits();geometryChanged();});
      }
      if (drumMode) el("[data-vd-drum-size]").addEventListener("change",geometryChanged);
      if (fixedPair) {
        widthInput.value = "8"; heightInput.value = "2"; proportionsLocked = false;
        widthInput.disabled = true; heightInput.disabled = true; lockButton.hidden = true;
        all("[data-vd-quick-size]").forEach(function(button){button.hidden=true;});
        el(".vd-decal__quick-sizes").hidden = true;
        el("[data-vd-wall-limits]").textContent = "Fixed at 8 inches wide × 2 inches tall. Each pair contains two identical decals.";
      }
      var profile=catalog.productProfile || {}, specialPrice=catalog.pricingProfile;
      if (profile.minimumWidth || specialPrice) {widthInput.min=String(profile.minimumWidth || specialPrice.min);widthInput.value=String(Math.max(Number(widthInput.value),Number(widthInput.min)));}
      if (profile.businessHoursStyle) widthInput.value="12";
      if (specialPrice && specialPrice.materials) {
        all("[data-vd-material]").forEach(function(input){var allowed=specialPrice.materials.indexOf(input.value)>=0;input.disabled=!allowed;input.closest("label").hidden=!allowed;input.checked=input.value===specialPrice.materials[0];});
      }
      if (specialPrice && specialPrice.sizes) {
        var listed=boatMode?el("[data-vd-boat-size]"):document.createElement("select");listed.replaceChildren();listed.setAttribute("aria-label","Choose exact finished size");
        specialPrice.sizes.forEach(function(size,i){var option=document.createElement("option");option.value=boatMode?String(size[0]):String(i);option.textContent=size[0]+' inches × '+size[1]+' inches'+(boatMode?" - pair":'');listed.append(option);});
        if(!boatMode)widthInput.parentNode.parentNode.append(listed);
        function applySize(){var size=specialPrice.sizes[boatMode?listed.selectedIndex:Number(listed.value)];widthInput.value=String(size[0]);heightInput.value=String(size[1]);proportionsLocked=false;}
        applySize();listed.addEventListener("change",function(){applySize();geometryChanged();});widthInput.disabled=true;heightInput.disabled=true;lockButton.hidden=true;
        all("[data-vd-quick-size]").forEach(function(button){button.hidden=true;});
      }
      if (profile.templateLayout === "fixed-rows") {widthInput.value="22";heightInput.value="2";widthInput.disabled=true;heightInput.disabled=true;proportionsLocked=false;lockButton.hidden=true;all("[data-vd-quick-size]").forEach(function(button){button.hidden=true;});}
      maximumLines = Number(catalog.maximumLines) || maximumLines;
      if (catalog.productProfile && catalog.productProfile.businessHoursStyle) {
        renderLineInputs(catalog.productProfile.initialText.split("\n"));
        el("[data-vd-add-line]").hidden = true; el("[data-vd-remove-line]").hidden = true;
        var help = document.createElement("p"); help.textContent = "Separate each day and hours with | (example MONDAY | 9 AM - 5 PM). Leave a day blank to omit it. Select Style line or a word to change its font.";
        lineInputsContainer.parentNode.append(help);
      }
      if (wallMode) {
        var initialValues = fixedPrefix ? [joinedText(multilineInputs())] : multilineInputs().map(function (input) { return input.value; });
        while (initialValues.length < (Number(catalog.initialLines) || 5)) initialValues.push("");
        renderLineInputs(initialValues.slice(0, maximumLines));
        text.value = joinedText(multilineInputs());
      }
      selectedFont = catalog.fonts.find(function (font) { return font.id === (catalog.productProfile && catalog.productProfile.defaultFont || (memorialMode ? "courgette-regular" : "anton-regular")); }) || catalog.fonts[0];
      renderSocialIcons();
      textRuns = [{ start: 0, end: text.value.length, fontId: selectedFont.id, sizePercent: 100 }];
      if (catalog.productProfile && catalog.productProfile.headingStyle && text.value.indexOf("\n") > 0) {
        var headingEnd = text.value.indexOf("\n");
        var bodyFont = catalog.fonts.find(function (font) { return font.id === "montserrat-regular"; }) || selectedFont;
        textRuns = [
          { start: 0, end: headingEnd, fontId: selectedFont.id, sizePercent: 200 },
          { start: headingEnd, end: text.value.length, fontId: bodyFont.id, sizePercent: 100 }
        ];
      }
      if (catalog.productProfile && catalog.productProfile.lineStyles) {
        var start=0; textRuns=text.value.split("\n").map(function(row,i){var style=catalog.productProfile.lineStyles[i] || {fontId:selectedFont.id,sizePercent:100}; var run={start:start,end:start+row.length+(i<text.value.split("\n").length-1?1:0),fontId:style.fontId,sizePercent:style.sizePercent};start=run.end;return run;});
      }
      if (catalog.productProfile && catalog.productProfile.monogram) textRuns=[{start:0,end:1,fontId:selectedFont.id,sizePercent:100},{start:1,end:2,fontId:selectedFont.id,sizePercent:180},{start:2,end:3,fontId:selectedFont.id,sizePercent:100}];
      previousText = text.value;
      renderColors();
      syncDimensionLimits();
      syncReverseAvailability();
      selectedCategory = catalog.productProfile && catalog.productProfile.fontCategory || "all";
      renderCategories();
      renderFontList();
      renderSelectionState();
      summary();
      status.hidden = true;
      layout.hidden = false;
      activateProductionDesigner(root);
      freeformController=window.VDFreeformEnabled(productHandle)?window.VDCreateFreeform(root,{text:function(){return text.value;},select:function(start,end){selectRange(start,end,false,false);},begin:function(){clearTimeout(timer);++requestNumber;invalidate();},changed:function(){invalidate();queueRender(80);}}):undefined;
      queueRender(0);
    }).catch(function (problem) {
      status.textContent = problem instanceof Error ? problem.message : "Designer could not load";
    });

    text.addEventListener("input", function () {
      reconcileRuns(text.value);
      selectionStart = text.selectionStart || 0;
      selectionEnd = text.selectionEnd || selectionStart;
      selectedRanges = selectionEnd > selectionStart ? [{ start: selectionStart, end: selectionEnd }] : [];
      renderSelectionState();
      geometryChanged();
    });
    if (socialMode) {
      el("[data-vd-add-social]").addEventListener("click", function () {
        var picker = el("[data-vd-social-picker]");
        picker.hidden = !picker.hidden;
        this.setAttribute("aria-expanded", String(!picker.hidden));
      });
    }
    if (wallMode && el("[data-vd-add-line]") && el("[data-vd-remove-line]")) {
      el("[data-vd-add-line]").addEventListener("click", function () {
        var values = multilineInputs().map(function (input) { return input.value; });
        if (values.length >= maximumLines) return;
        values.push("");
        renderLineInputs(values, values.length - 1);
        syncMultilineText(multilineInputs()[values.length - 1]);
      });
      el("[data-vd-remove-line]").addEventListener("click", function () {
        var inputs = multilineInputs();
        if (inputs.length <= (memorialMode ? 3 : 1)) return;
        var last = inputs[inputs.length - 1];
        if (last.value && !window.confirm("Remove line " + inputs.length + " and its text?")) return;
        var values = inputs.slice(0, -1).map(function (input) { return input.value; });
        renderLineInputs(values, values.length - 1);
        syncMultilineText(multilineInputs()[values.length - 1]);
      });
    }
    ["select", "keyup", "mouseup", "touchend"].forEach(function (eventName) {
      text.addEventListener(eventName, captureSelection);
    });
    fontSize.addEventListener("change", function () {
      applyStyle({ sizePercent: Number(fontSize.value) });
    });
    el("[data-vd-size-down]").addEventListener("click", function () {
      var options = Array.from(fontSize.options);
      applyStyle(function (run) {
        var index = options.findIndex(function (option) { return Number(option.value) >= run.sizePercent; });
        if (index < 0) index = options.length - 1;
        return { sizePercent: Number(options[Math.max(0, index - 1)].value) };
      });
    });
    el("[data-vd-size-up]").addEventListener("click", function () {
      var options = Array.from(fontSize.options);
      applyStyle(function (run) {
        var index = options.findIndex(function (option) { return Number(option.value) > run.sizePercent; });
        if (index < 0) index = options.length - 1;
        return { sizePercent: Number(options[index].value) };
      });
    });
    widthInput.addEventListener("input", function () { sizingBasis = "width"; geometryChanged(); });
    heightInput.addEventListener("input", function () { sizingBasis = "height"; geometryChanged(); });
    lockButton.addEventListener("click", function () {
      proportionsLocked = !proportionsLocked;
      lockButton.setAttribute("aria-pressed", String(proportionsLocked));
      lockButton.textContent = proportionsLocked ? "🔒 Keep proportions" : "🔓 Free size";
      if (proportionsLocked) sizingBasis = "width";
      distortionAccepted = false;
      distortionAck.checked = false;
      geometryChanged();
    });
    all("[data-vd-quick-size]").forEach(function (button) {
      button.addEventListener("click", function () {
        widthInput.value = button.dataset.vdQuickSize;
        sizingBasis = "width";
        geometryChanged();
      });
    });
    el("[data-vd-keep-distortion]").addEventListener("click", function () {
      distortionAccepted = true;
      distortionAck.focus();
      updateApprovalState();
    });
    el("[data-vd-restore-width]").addEventListener("click", function () {
      proportionsLocked = true; sizingBasis = "width"; lockButton.setAttribute("aria-pressed", "true");
      lockButton.textContent = "🔒 Keep proportions"; geometryChanged();
    });
    el("[data-vd-restore-height]").addEventListener("click", function () {
      proportionsLocked = true; sizingBasis = "height"; lockButton.setAttribute("aria-pressed", "true");
      lockButton.textContent = "🔒 Keep proportions"; geometryChanged();
    });
    distortionAck.addEventListener("change", function () {
      updateApprovalState();
    });
    all("[data-vd-reversed]").forEach(function (input) { input.addEventListener("change", geometryChanged); });
    color.addEventListener("change", function () {
      summary();
      queueQuote();
    });
    quantity.addEventListener("input", function () {
      summary();
      queueQuote();
    });
    all("[data-vd-material]").forEach(function (input) {
      input.addEventListener("change", function () {
        renderColors();
        syncDimensionLimits();
        var reversedChanged = syncReverseAvailability();
        summary();
        if (wallMode || reversedChanged) geometryChanged();
        else queueQuote();
      });
    });
    editAll.addEventListener("click", function () { selectRange(0, 0, false, false); });
    el("[data-vd-undo]").addEventListener("click", function () {
      if (!styleHistory.length) return;
      restoreRuns(styleHistory.pop());
      el("[data-vd-undo]").disabled = !styleHistory.length;
    });
    el("[data-vd-reset-selected]").addEventListener("click", function () {
      applyStyle({ fontId: catalog.fonts[0].id, sizePercent: 100 });
    });
    el("[data-vd-reset-all]").addEventListener("click", function () {
      var priorRanges = selectedRanges;
      selectedRanges = [{ start: 0, end: text.value.length }];
      applyStyle({ fontId: catalog.fonts[0].id, sizePercent: 100 });
      selectedRanges = priorRanges;
      renderSelectionState();
    });
    search.addEventListener("input", renderFontList);
    el("[data-vd-font-more]").addEventListener("click", function () {
      fontListExpanded = true;
      renderFontList();
    });
    approval.addEventListener("change", function () {
      updateApprovalState();
    });
    submit.addEventListener("click", approveAndAdd);
  }

  function boot() {
    var primary = document.querySelector("[data-vd-decal-designer]:not([data-vd-fallback])");
    document.querySelectorAll("[data-vd-decal-designer][data-vd-fallback]").forEach(function (fallback) {
      if (primary) {
        fallback.remove();
        return;
      }
      fallback.hidden = false;
      placeProductionDesigner(fallback);
    });
    document.querySelectorAll("[data-vd-decal-designer]").forEach(init);
  }
  boot();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  if (window.MutationObserver) {
    var observer = new window.MutationObserver(boot);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }
}());
